import { computed } from 'vue';
import type { ITopolPageProps } from '@/types/TopolPageProps/TopolPageProps';

export function useGtm() {
    const globalProps = computed(() => usePage<ITopolPageProps>().props);

    const pushEvent = (
        eventName: string,
        customData: Record<string, any> = {}
    ) => {
        if (typeof window !== 'undefined' && window.dataLayer) {
            // Always include userId and email from globalProps
            const baseData = {
                userId: globalProps.value.user.id,
                email: globalProps.value.user.email,
            };

            window.dataLayer.push({
                event: eventName,
                ...baseData,
                ...customData, // custom data overrides if keys overlap
            });
        } else {
            console.warn('[GTM] dataLayer is not defined');
        }
    };

    return { pushEvent };
}
